import { HttpClient } from '@angular/common/http';
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material';
import { AppService } from 'src/@core/services/app.service';
import { ThemeService } from 'src/@core/services/theme.service';
import { API_ACCOUNT_CREDIT } from 'src/@core/services/util/api.endpoints';
import { WorkflowPopupComponent } from '../../workflow-popup/workflow-popup.component';
import { WorkflowDataService } from 'src/@core/services/job/workflow-data.service';
import { NotificationService } from 'src/@core/services/notification.service';
import { EnterpriseAdminService } from 'src/app/modules/enterprise-admin/enterprise-admin.service';
import { Router } from '@angular/router';
import logoLinkedIn from '@iconify/icons-logos/linkedin';
import logoGitHub from '@iconify/icons-logos/github';
import logoTwitter from '@iconify/icons-logos/twitter';
import logoFacebook from '@iconify/icons-logos/facebook';
@Component({
  selector: 'hour4u-admin-client-profile',
  templateUrl: './client-profile.component.html',
  styleUrls: ['./client-profile.component.scss']
})
export class ClientProfileComponent implements OnInit, OnDestroy {
  selectedTabIndex: number = 0;
  profile = this.appService.getCurrentAccount();
  credits: any = null;
  remainingCredits: number;
  workflowPopupData: any[];
  intervalId: any;
  logoLinkedIn = logoLinkedIn;
  logoGitHub = logoGitHub;
  logoTwitter = logoTwitter;
  logoFacebook = logoFacebook;
  candidateDetails: any = null;
  activeTranscriptJobId: string | null = null;

  private transcriptJobPollIntervalId: any = null;
  private transcriptJobPollAttempts = 0;
  private transcriptJobPollMaxAttempts = 15; // ~30s @ 2s interval
  private transcriptJobPollPrevJobId: string | null = null;

  constructor(
    public dialogRef: MatDialogRef<ClientProfileComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public themeService: ThemeService,
    private http: HttpClient,
    private appService: AppService,
    private dialog: MatDialog,
    private workflowDataService: WorkflowDataService,
    private notify: NotificationService,
    public enterpriseAdminService: EnterpriseAdminService,
    private router: Router
  ) { }

  ngOnInit() {
    console.log(this.data, this.data.callDetails)
    // Set initial tab index if provided in data
    if (this.data.selectedTabIndex !== undefined) {
      this.selectedTabIndex = this.data.selectedTabIndex;
    }
    this.fetchCandidateProfileDetails();
  }

  ngOnDestroy(): void {
    this.stopTranscriptJobPolling();
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  private computeLatestCallJobId(details: any): string | null {
    const calls = details && details.data && Array.isArray(details.data) ? details.data : null;
    if (!calls || !calls.length) return null;

    let latest: any = null;
    let latestTs = -1;

    for (let i = 0; i < calls.length; i++) {
      const c = calls[i];
      if (!c) continue;

      const rawTs = c.last_updated || c.recording_time || c.start_time || c.end_time;
      const tsNum = rawTs !== undefined && rawTs !== null ? Number(rawTs) : NaN;
      const ts = isNaN(tsNum) ? -1 : tsNum;

      if (ts > latestTs) {
        latestTs = ts;
        latest = c;
      }
    }

    if (latest && latest.job_id) return String(latest.job_id);
    return null;
  }

  getJobIdForTranscript(): string | null {
    const computed = this.computeLatestCallJobId(this.candidateDetails);
    if (computed) return computed;

    // Fallback to dialog-provided callDetails
    const cd = this.data && this.data.callDetails ? this.data.callDetails : null;
    const fallbackJobId = cd ? (cd.job_id || cd.jobId || cd.jobID || cd.id || cd.job) : null;
    return fallbackJobId ? String(fallbackJobId) : null;
  }

  fetchCandidateProfileDetails() {
    this.enterpriseAdminService.fetchCandidatesDeatails(this.data.callDetails.people_id, this.data.callDetails.project_id, this.data.callDetails.client_number).subscribe(res => {
      console.log(res)
      this.candidateDetails = res;
      const latestJobId = this.computeLatestCallJobId(res);
      if (latestJobId && latestJobId !== this.activeTranscriptJobId) {
        this.activeTranscriptJobId = latestJobId;
      } else if (!this.activeTranscriptJobId) {
        // initial fallback if API doesn't return calls yet
        this.activeTranscriptJobId = this.getJobIdForTranscript();
      }

      if (this.transcriptJobPollIntervalId && this.transcriptJobPollPrevJobId && this.activeTranscriptJobId && this.activeTranscriptJobId !== this.transcriptJobPollPrevJobId) {
        this.stopTranscriptJobPolling();
      }
    })
  }

  private startTranscriptJobPolling(prevJobId: string | null): void {
    this.stopTranscriptJobPolling();
    this.transcriptJobPollPrevJobId = prevJobId;
    this.transcriptJobPollAttempts = 0;

    this.transcriptJobPollIntervalId = setInterval(() => {
      this.transcriptJobPollAttempts++;
      this.fetchCandidateProfileDetails();

      if (this.transcriptJobPollAttempts >= this.transcriptJobPollMaxAttempts) {
        this.stopTranscriptJobPolling();
      }
    }, 2000);
  }

  private stopTranscriptJobPolling(): void {
    if (this.transcriptJobPollIntervalId) {
      clearInterval(this.transcriptJobPollIntervalId);
      this.transcriptJobPollIntervalId = null;
    }
    this.transcriptJobPollAttempts = 0;
    this.transcriptJobPollPrevJobId = null;
  }

  // tab change
  onTabChanged(event) {
    console.log(event, event.tab.textLabel)
    // if (event.tab.textLabel === "Purchase orders") {
    //   this.jobService.setRefreshPOPage();
    // }
  }

  // get Credits
  getCredits() {
    this.http.get(API_ACCOUNT_CREDIT + '/' + this.profile.entity.id).subscribe(
      (response: any) => {
        if (response) {
          // response.remainCredits = response.taskCredits - response.usedCredits;
          // this.credits = response;
          this.remainingCredits = response.taskCredits - response.usedCredits;
          console.log("Credits", this.remainingCredits)
        }
      })
  }

  getCustomerInitials(): string {
    const name = (this.candidateDetails && this.candidateDetails.client_name) ||
      (this.candidateDetails && this.candidateDetails.name) ||
      (this.data && this.data.callDetails && this.data.callDetails.client_name) ||
      '';
    if (name) {
      const nameParts = name.trim().split(' ');
      if (nameParts.length >= 2) {
        return (nameParts[0][0] + nameParts[1][0]).toUpperCase();
      } else {
        return name.substring(0, 2).toUpperCase();
      }
    }
    return 'NA';
  }

  getCustomerPhoneNumber(): string {
    return (this.candidateDetails && this.candidateDetails.client_number) ||
      (this.data && this.data.callDetails && this.data.callDetails.client_number) ||
      'N/A';
  }

  openWorkflowPopup(details: any) {
    console.log(details)
    // return;
    this.getCredits();

    if (this.remainingCredits <= 0) {
      this.notify.showMessage(
        `Please topup your credits to proceed!`,
        30000
      );
      return;
    } else {
      // console.log(this.selection, this.data.projectDetails);
      this.workflowPopupData = [];
      // Use details or fallback to callDetails
      const clientData = details || this.data.callDetails;
      if (clientData && clientData.client_email != "Reveal") {
        // this.selection.selected.forEach(element => {
        let obj = {
          "client_name": this.data.callDetails.client_name,
          "client_email": this.data.callDetails.client_email || (this.candidateDetails && this.candidateDetails.client_email) || (this.candidateDetails && this.candidateDetails.email),
          "client_number": this.data.callDetails.client_number || (this.data && this.data.callDetails && this.data.callDetails.client_number),
          "entity_id": this.profile.entity.id,
          "project_id": this.data.projectDetails.project_id,
          "workflowType": "call",
          "people_id": clientData.people_id || (this.data && this.data.callDetails && this.data.callDetails.people_id),
        }
        this.workflowPopupData.push(obj);
        // });

      } else {
        this.workflowPopupData = this.data.projectDetails;
      }

      if (this.data.projectDetails.final_prompt === undefined) {
        const dialogRef = this.dialog.open(WorkflowPopupComponent, {
          width: '640px',
          panelClass: 'add-edit-staff-dialog',
          disableClose: true,
          data: this.workflowPopupData
        });

        // Listen for the event from popup
        dialogRef.componentInstance.workflowSetup.subscribe((result) => {
          console.log("Workflow setup data:", result);

          // ✅ Store data in service before navigation
          this.workflowDataService.setWorkflowData(this.workflowPopupData);

          // Navigate to workflow-stepper page with project ID and workflow type query param
          const workflowType = (result && result.workflowType) ? result.workflowType : null;
          const navigationExtras = workflowType ? { queryParams: { workflowType: workflowType } } : {};
          this.router.navigate([`/job/view-new-project/${this.data.projectDetails.project_id}/setup-workflow`], navigationExtras);
        });

        dialogRef.afterClosed().subscribe(result => {
          console.log("Popup closed");
        });
      } else {
        let obj = [{
          "client_name": this.data.callDetails.client_name,
          "client_email": this.data.callDetails.client_email,
          "client_number": this.data.callDetails.client_number,
          "entity_id": this.profile.entity.id,
          "tts": "elevenlabs",
          "language": this.data.projectDetails.labguage || "en",
          "voice": this.data.projectDetails.voice || "male",
        }]

        // Start polling immediately when initiating the call request (don't wait for API response),
        // because the new job_id may appear in getAllJobsStatusByClient while /v1/call is still pending.
        const prevJobId = this.activeTranscriptJobId || this.getJobIdForTranscript();
        this.startTranscriptJobPolling(prevJobId);

        this.enterpriseAdminService.callSelectedUsers(this.data.projectDetails.agent_id, this.data.projectDetails.project_id, this.data.projectDetails.entity_id, obj).subscribe(res => {
          this.notify.showMessage(
            `Calling users...`,
            30000
          );
          this.intervalId = setInterval(() => {
            if (res && res.length) {
              //this.getUpdatingStatus(res[0].job_id);
            }
          }, 3000);
        }, (err => {
          console.log(err)
        }))
      }
    }
  }

}
